module.exports = __webpack_public_path__ + "static/prof-c007af8ff544eae7c7eb58310c7e863e.jpg";